package org.testadirapa.cardtraderscout.utils

data object Void